<div class="clearfix {{titleColor}}" cdkDropList (cdkDropListDropped)="onDropCDK($event)">
  <div cdkDrag class="cms-section clearfix {{titleColor}} sectionborder" id="{{section?.section_id}}"
    *ngFor="let section of newsletterSections">
    <div class="cms-default-section1 cms-section clearfix">
      <div class="cms-section-controls clearfix">
        <!-- <div class="cms-control-button section-pos">
          <a title="Section Position">
            Pos: {{section?.section_pos}}
          </a>
        </div> -->
        <div class="cms-control-button  section-clone">
          <a title="Clone/Copy this Section">
            <span>clone</span>
          </a>
        </div>
        <div class="cms-control-button section-delete">
          <!-- <a title="Delete this Section" (click)="deleteSectionPopup(section)">
            <span>delete</span>
          </a> -->
          <span class="basic-icon delete-icon center-text"
            style="width: 23px; height: 23px; transform: translate(-50%, 15%);" (click)="deleteSection(section)"></span>
        </div>
        <div class="cms-control-button section-move">
          <a title="Move this Section">
            <span>move</span>
          </a>
        </div>
        <div class="cms-control-button section-move-up" style="float: left;">
          <a title="Move this Section up" (click)="moveUp(section)">
            <span>up</span>
          </a>
        </div>
        <div class="cms-control-button section-move-down" style="float: left;">
          <a title="Move this Section down" (click)="moveDown(section)">
            <span>down</span>
          </a>
        </div>
        <div *ngIf="newletterToEditId == section.section_id && addingTitle != ''" class="create-loading">
          <mat-spinner diameter="20"></mat-spinner> {{addingTitle}}
        </div>
      </div>
      <div class="cms-collction-row clearfix">
        <div class="cms-section-column">
          <div class="cms-head cms-editable-area" (click)="editSectionTitle(section)">
            <h2 class="cms-editable-element">
              {{section?.content?section?.content:"Section Name"}}
            </h2>
          </div>

          <ng-container *ngIf="newsletterInfo">
            <app-newsletter-section-block-v2 [newsletterInfo]="newsletterInfo" [sendSectionToBlock]="section" (loadingTitleEvent)="loadingTitleEvent($event)"
              (editBlockEvent)="receiveEditBlockEvent($event)" [newsletterEditViewModel]="newsletterEditViewModel"></app-newsletter-section-block-v2>
          </ng-container>

          <div class="cms-block-controls clearfix cms-add">
            <div class="cms-control-button block-add-heading">
              <a class="red-link" (click)="addBlock(section?.section_id, 'nl_heading')">
                <span>add heading</span>
              </a>
            </div>
            <div class="cms-control-button block-add-products">
              <a class="red-link" (click)="addBlock(section?.section_id, 'products')">
                <span>add product list</span>
              </a>
            </div>
            <div class="cms-control-button block-add-comment">
              <a class="red-link" (click)="addBlock(section?.section_id, 'nl_comment')">
                <span>add comment</span>
              </a>
            </div>
            <div class="cms-control-button block-add-link">
              <a class="red-link" (click)="addBlock(section?.section_id, 'link')">
                <span>add link</span>
              </a>
            </div>
          </div>
        </div>
        <!-- .cms-section-column ends -->
      </div>
      <!-- .cms-collction-row ends -->
    </div>
  </div>
</div>